
// font-constant.tsx
import { createGlobalStyle } from 'styled-components';

export const FontStyles = createGlobalStyle`
  body {
    font-family: 'Inter', sans-serif;
  }
`;
